import { makeStyles } from 'tss-react/mui'


const useStyles = makeStyles()((theme) => ({
    container: {
        position: 'relative',
        overflow: 'visible'
    },
    topBar: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        minWidth: '100%',
        height: '40px',
    },
    bottomBar: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        minWidth: '100%',
        position: 'relative',
        justifyContent: 'space-between',
        height: '36px',
        maxHeight: '36px',
        minHeight: '36px',
        overflow: 'visible',
        boxSizing: 'border-box'
    },
    bottomBarScroll: {
        flex: 1,
        minWidth: 0,
        display: 'flex',
        alignItems: 'center'
    },
    divider: {
        width: '100%'
    }
}))

export default useStyles